import { isTV } from "../utils/platform";
import { UserSubscriptionStatus } from "@onmo/graphql/graphql";

export const STORAGE_FULLSCREEN = "isFullscreen";
export const STORAGE_SOUND = "isSoundOn";

export const getFullscreenStorageKey = (profileId?: string) =>
  profileId ? `${STORAGE_FULLSCREEN}:${profileId}` : STORAGE_FULLSCREEN;

export const getSoundStorageKey = (profileId?: string) =>
  profileId ? `${STORAGE_SOUND}:${profileId}` : STORAGE_SOUND;

export const setActivationCode = (code: string) => {
  return localStorage.setItem("activationCode", code);
};

export const getActivationCode = () => {
  return localStorage.getItem("activationCode") || "";
};

export const clearActivationCode = () => {
  return localStorage.removeItem("activationCode");
};

export const isShowActivation = () => {
  const activationCode = getActivationCode();
  return activationCode && activationCode !== "skipped" && !isTV;
};

export const isShowPaywall = (status?: UserSubscriptionStatus) => {
  const activationCode = getActivationCode();

  return (
    !activationCode && !isTV && status === UserSubscriptionStatus.NotSubscribed
  );
};

export const setSkippedActivationCode = () => {
  return localStorage.setItem("activationCode", "skipped");
};
